export const categories = [
  {
    id: 'dianying',
    name: '电影',
    slug: 'dianying',
    icon: 'ri-movie-2-line',
    description: '热门电影推荐，涵盖动作、喜剧、科幻、爱情等多种类型',
    color: 'accent',
  },
  {
    id: 'dianshiju',
    name: '电视剧',
    slug: 'dianshiju',
    icon: 'ri-tv-2-line',
    description: '最新电视剧连载，都市情感、古装悬疑、青春偶像剧',
    color: 'primary',
  },
  {
    id: 'zongyi',
    name: '综艺',
    slug: 'zongyi',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺节目，音乐竞演、真人秀、脱口秀等精彩内容',
    color: 'secondary',
  },
  {
    id: 'dongman',
    name: '动漫',
    slug: 'dongman',
    icon: 'ri-ancient-gate-line',
    description: '国内外热门动漫，热血、奇幻、校园、治愈等全类型覆盖',
    color: 'accent',
  },
  {
    id: 'jilupian',
    name: '纪录片',
    slug: 'jilupian',
    icon: 'ri-earth-line',
    description: '高分纪录片精选，自然地理、人文历史、科技创新',
    color: 'primary',
  },
  {
    id: 'yinyue',
    name: '音乐',
    slug: 'yinyue',
    icon: 'ri-music-2-line',
    description: 'MV、演唱会、音乐节目，享受高品质视听盛宴',
    color: 'secondary',
  },
  {
    id: 'tiyu',
    name: '体育',
    slug: 'tiyu',
    icon: 'ri-basketball-line',
    description: '精彩体育赛事回放、集锦，足球、篮球、电竞全覆盖',
    color: 'accent',
  },
  {
    id: 'keji',
    name: '科技',
    slug: 'keji',
    icon: 'ri-cpu-line',
    description: '科技前沿资讯、数码评测、AI趋势解读',
    color: 'primary',
  },
];

export const categoryColorMap: Record<string, { bg: string; text: string; border: string }> = {
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', border: 'border-accent-300' },
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', border: 'border-primary-300' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', border: 'border-secondary-300' },
};

export const getCategoryBySlug = (slug: string) => categories.find((c) => c.slug === slug);